import RegisterApi from '../api/RegisterApi';

const asyncValidate = (values, dispatch, props) => (
  RegisterApi.checkUniqueEmail(values.email).then((isUnique) => {
    if (!isUnique.data) {
      props.updateIsUniqueEmail(false);
      // eslint-disable-next-line no-throw-literal
      throw { email: 'Email already registered. Want to sign in?' };
    } else {
      props.updateIsUniqueEmail(true);
    }
  })
);

export default asyncValidate;
